import { graphql } from 'react-relay';

export const frontPageFragment = graphql`
  fragment FrontPage_page on FrontPage {
    firstGroup {
      __typename
      ...LinkGroup_frontGroup
      ...LinkListGroup_frontGroup
    }
    secondGroup {
      __typename
      ...LinkGroup_frontGroup
      ...LinkListGroup_frontGroup
    }
    thirdGroup {
      __typename
      ...LinkGroup_frontGroup
      ...LinkListGroup_frontGroup
    }
  }
`;
